import rcmd from './rcmd'
import url from './url'

export default {
  rcmd,
  url
}
